import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { TaskStatus } from 'types/common';
import { TaskManagementFilters } from '../useTaskManagementFilters';
import { convertTaskFiltersToApiParams } from 'screens/task-management/util';

type AgTask = {
  failedCount: number;
  overdueCount: number;
  activeCount: number;
  completedCount: number;
  upcomingCount: number;
  agronomistName: string;
  taskList: TaskItem[];
};

type TaskItem = {
  taskId: string;
  startDate: string; // ISO date string
  endDate: string; // ISO date string
  plannedDate: string; // ISO date string
  agronomistId: string;
  agronomistName: string;
  plantingGroupId: string;
  plantingGroupName: string;
  status: TaskStatus;
  taskDescription: string;
};

type AgTaskT = Record<string, AgTask>;

const useAgTaskQuery = (params?: TaskManagementFilters) => {
  const queryParams = useMemo(
    () => convertTaskFiltersToApiParams(params),
    [params],
  );
  const query = useQuery<AxiosResponse<AgTaskT>>({
    queryKey: ['ag-task', queryParams],
    queryFn: () =>
      API.get('/taskassignment/weekly/agronomist', { params: queryParams }),
  });

  const flattenedData = useMemo(
    () => (query?.data?.data ? Object.values(query?.data?.data) : []),
    [query?.data?.data],
  );

  return {
    data: query.data,
    error: query.error,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    flattenedData,
  };
};

export default useAgTaskQuery;
